export const joinClasses = (classes: any) => classes.join(' ');
